<div class="slider-container">
    <button mat-fab class="flecha-izquierda" (click)="onClickLeft()">
        <mat-icon class="arrow-icon">
            keyboard_arrow_left</mat-icon>
    </button>
    <div class="slides" #slides>
        <ng-content select="[appSliderItem]" #sliderItem></ng-content>
    </div>
    <button mat-fab class="flecha-derecha" (click)="onClickRight()">
        <mat-icon class="arrow-icon">
            keyboard_arrow_right</mat-icon>
    </button>
</div>